import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Language, LanguageService } from 'itcores-fw';
import { Router } from '@angular/router';
import { AppUrls } from '../../helpers/app-urls';
import { AuthService } from 'src/app/modules/auth/services/auth.service';

@Component({
  selector: 'app-not-authorized-page',
  templateUrl: './not-authorized-page.component.html',
  styleUrls: ['./not-authorized-page.component.scss']
})
export class NotAuthorizedPageComponent implements OnInit {
  /* #region  Fields  */
  changeLang: Language;
  notAuth:
    { error: string, nump: string, message: string };

  /* #endregion */

  /* #region  Constructor */
  constructor(
    private _location: Location,
    private _language: LanguageService,
    private router: Router,
    private authService: AuthService
  ) { }
  /* #endregion */

  /* #region  Event */
  ngOnInit() {
    (this.notAuth as any) = {};
    this._language.LangChanged.subscribe(value => {
      this.changeLang = value;
      this.getPageTranslated();
    });
    this.getPageTranslated();
  }
  /* #endregion */

  /* #region  Methods */

  getPageTranslated() {
    this.changeLang === 'en' ?
      this.notAuth = {
        error: 'Error',
        message: 'Not Authorized to Access page',
        nump: '401'
      } : this.notAuth = {
        error: 'خطأ',
        message: 'ليس لديك صلاحية للوصول لهذه الصفحة',
        nump: '401'
      };
  }

  goBack() {
    this._location.back();
  }

  goToLandingPage() {
    this.router.navigate([AppUrls.landing]);
  }

  logout() {
    this.authService.logout();
  }

  /* #endregion */
}
